/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Cloud API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CloudAlarmResponse,
  CloudCommonDetailResponse,
  CloudCommonResourceListResponse,
  CloudCommonServiceResponse,
  CloudCommonViewRequestBody,
  CloudResourceByCloudResponse,
  CloudResourceByServiceResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 클라우드 > 컴퓨팅, 스토리지, 데이터베이스 ... > 오버뷰 > 최근 클라우드 알람
 * @summary getCloudAlarm
 */
export const postV8CloudCommonOverviewCloudAlarm = (
  cloudCommonViewRequestBody: MaybeRef<CloudCommonViewRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  cloudCommonViewRequestBody = unref(cloudCommonViewRequestBody);

  return customAxiosInstance<CloudAlarmResponse>(
    {
      url: `/api/v8/cloud/common/overview/cloud-alarm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cloudCommonViewRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8CloudCommonOverviewCloudAlarmMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8CloudCommonOverviewCloudAlarm>>,
    TError,
    { data: BodyType<CloudCommonViewRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewCloudAlarm>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8CloudCommonOverviewCloudAlarm'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8CloudCommonOverviewCloudAlarm>>,
    { data: BodyType<CloudCommonViewRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8CloudCommonOverviewCloudAlarm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8CloudCommonOverviewCloudAlarmMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewCloudAlarm>>
>;
export type PostV8CloudCommonOverviewCloudAlarmMutationBody = BodyType<CloudCommonViewRequestBody>;
export type PostV8CloudCommonOverviewCloudAlarmMutationError = ErrorType<unknown>;

/**
 * @summary getCloudAlarm
 */
export const usePostV8CloudCommonOverviewCloudAlarm = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8CloudCommonOverviewCloudAlarm>>,
      TError,
      { data: BodyType<CloudCommonViewRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewCloudAlarm>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8CloudCommonOverviewCloudAlarmMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getResourceByCloud
 */
export const postV8CloudCommonOverviewResourceByCloud = (
  cloudCommonViewRequestBody: MaybeRef<CloudCommonViewRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  cloudCommonViewRequestBody = unref(cloudCommonViewRequestBody);

  return customAxiosInstance<CloudResourceByCloudResponse>(
    {
      url: `/api/v8/cloud/common/overview/resource-by-cloud`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cloudCommonViewRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8CloudCommonOverviewResourceByCloudMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByCloud>>,
    TError,
    { data: BodyType<CloudCommonViewRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByCloud>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8CloudCommonOverviewResourceByCloud'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByCloud>>,
    { data: BodyType<CloudCommonViewRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8CloudCommonOverviewResourceByCloud(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8CloudCommonOverviewResourceByCloudMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByCloud>>
>;
export type PostV8CloudCommonOverviewResourceByCloudMutationBody =
  BodyType<CloudCommonViewRequestBody>;
export type PostV8CloudCommonOverviewResourceByCloudMutationError = ErrorType<unknown>;

/**
 * @summary getResourceByCloud
 */
export const usePostV8CloudCommonOverviewResourceByCloud = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByCloud>>,
      TError,
      { data: BodyType<CloudCommonViewRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByCloud>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8CloudCommonOverviewResourceByCloudMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getResourceByService
 */
export const postV8CloudCommonOverviewResourceByService = (
  cloudCommonViewRequestBody: MaybeRef<CloudCommonViewRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  cloudCommonViewRequestBody = unref(cloudCommonViewRequestBody);

  return customAxiosInstance<CloudResourceByServiceResponse>(
    {
      url: `/api/v8/cloud/common/overview/resource-by-service`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cloudCommonViewRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8CloudCommonOverviewResourceByServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByService>>,
    TError,
    { data: BodyType<CloudCommonViewRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByService>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8CloudCommonOverviewResourceByService'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByService>>,
    { data: BodyType<CloudCommonViewRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8CloudCommonOverviewResourceByService(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8CloudCommonOverviewResourceByServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByService>>
>;
export type PostV8CloudCommonOverviewResourceByServiceMutationBody =
  BodyType<CloudCommonViewRequestBody>;
export type PostV8CloudCommonOverviewResourceByServiceMutationError = ErrorType<unknown>;

/**
 * @summary getResourceByService
 */
export const usePostV8CloudCommonOverviewResourceByService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByService>>,
      TError,
      { data: BodyType<CloudCommonViewRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8CloudCommonOverviewResourceByService>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8CloudCommonOverviewResourceByServiceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getResourceList
 */
export const postV8CloudCommonResourceList = (
  cloudCommonViewRequestBody: MaybeRef<CloudCommonViewRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  cloudCommonViewRequestBody = unref(cloudCommonViewRequestBody);

  return customAxiosInstance<CloudCommonResourceListResponse>(
    {
      url: `/api/v8/cloud/common/resource/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cloudCommonViewRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8CloudCommonResourceListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8CloudCommonResourceList>>,
    TError,
    { data: BodyType<CloudCommonViewRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8CloudCommonResourceList>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8CloudCommonResourceList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8CloudCommonResourceList>>,
    { data: BodyType<CloudCommonViewRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8CloudCommonResourceList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8CloudCommonResourceListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8CloudCommonResourceList>>
>;
export type PostV8CloudCommonResourceListMutationBody = BodyType<CloudCommonViewRequestBody>;
export type PostV8CloudCommonResourceListMutationError = ErrorType<unknown>;

/**
 * @summary getResourceList
 */
export const usePostV8CloudCommonResourceList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8CloudCommonResourceList>>,
      TError,
      { data: BodyType<CloudCommonViewRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8CloudCommonResourceList>>,
  TError,
  { data: BodyType<CloudCommonViewRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8CloudCommonResourceListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 클라우드 공통뷰에서 리소스 선택 시 상세 정보를 조회합니다. 
25.07.02 [DSP-27139] dynamodb billingMode 필드 추가
 * @summary getResourceDetail
 */
export const getV8CloudCommonByCloudAndServiceAndResourceId = (
  cloud: MaybeRef<'aws' | 'azure'>,
  service: MaybeRef<string>,
  resourceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  cloud = unref(cloud);
  service = unref(service);
  resourceId = unref(resourceId);

  return customAxiosInstance<CloudCommonDetailResponse>(
    { url: `/api/v8/cloud/common/${cloud}/${service}/${resourceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8CloudCommonByCloudAndServiceAndResourceIdQueryKey = (
  cloud?: MaybeRef<'aws' | 'azure'>,
  service?: MaybeRef<string>,
  resourceId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'cloud', 'common', cloud, service, resourceId] as const;
};

export const getGetV8CloudCommonByCloudAndServiceAndResourceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>,
  TError = ErrorType<unknown>,
>(
  cloud: MaybeRef<'aws' | 'azure'>,
  service: MaybeRef<string>,
  resourceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CloudCommonByCloudAndServiceAndResourceIdQueryKey(
    cloud,
    service,
    resourceId,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>
  > = ({ signal }) =>
    getV8CloudCommonByCloudAndServiceAndResourceId(
      cloud,
      service,
      resourceId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(cloud) && unref(service) && unref(resourceId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>,
    TError,
    TData
  >;
};

export type GetV8CloudCommonByCloudAndServiceAndResourceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>
>;
export type GetV8CloudCommonByCloudAndServiceAndResourceIdQueryError = ErrorType<unknown>;

/**
 * @summary getResourceDetail
 */

export function useGetV8CloudCommonByCloudAndServiceAndResourceId<
  TData = Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>,
  TError = ErrorType<unknown>,
>(
  cloud: MaybeRef<'aws' | 'azure'>,
  service: MaybeRef<string>,
  resourceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8CloudCommonByCloudAndServiceAndResourceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CloudCommonByCloudAndServiceAndResourceIdQueryOptions(
    cloud,
    service,
    resourceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getResourceService
 */
export const getV8CloudCommonServiceByResourceId = (
  resourceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  resourceId = unref(resourceId);

  return customAxiosInstance<CloudCommonServiceResponse>(
    { url: `/api/v8/cloud/common/${resourceId}/service`, method: 'GET', signal },
    options,
  );
};

export const getGetV8CloudCommonServiceByResourceIdQueryKey = (resourceId?: MaybeRef<string>) => {
  return ['api', 'v8', 'cloud', 'common', resourceId, 'service'] as const;
};

export const getGetV8CloudCommonServiceByResourceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>,
  TError = ErrorType<unknown>,
>(
  resourceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CloudCommonServiceByResourceIdQueryKey(resourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>> = ({
    signal,
  }) => getV8CloudCommonServiceByResourceId(resourceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(resourceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>,
    TError,
    TData
  >;
};

export type GetV8CloudCommonServiceByResourceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>
>;
export type GetV8CloudCommonServiceByResourceIdQueryError = ErrorType<unknown>;

/**
 * @summary getResourceService
 */

export function useGetV8CloudCommonServiceByResourceId<
  TData = Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>,
  TError = ErrorType<unknown>,
>(
  resourceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8CloudCommonServiceByResourceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CloudCommonServiceByResourceIdQueryOptions(resourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
